/**
 * One-time boot sweep: deletes dead client storage no code reads anymore, so a long-lived browser
 * gets its quota back and never carries dead evidence forward. `playerProfile.serde.*` (including
 * its `.corrupt-*` quarantine variants) retired with the client-serde-retirement follow-up
 * (2026-07-12) — player-profile.js's serde half is gone, so nothing will ever read these keys
 * again. `browserId` retired with the identity-retirement tail (2026-07-15) — the
 * identity-cookies.js mirror stopped writing it and `DeviceTokenFilter`'s adoption seam stopped
 * reading it, in the same PR. `multiplayerSectionOpen` retired with the start-screen-multiplayer-
 * row change (2026-08-22) — the section is collapsed on every mount now, expanding it is always a
 * deliberate act, so game-start-multiplayer-section.js neither writes nor reads the remembered
 * state anymore; unlike `browserId` this key has no cookie twin, so the localStorage sweep below
 * is the whole cleanup. A flat prefix list so a future sweep addition is a one-line array entry,
 * not a new function.
 *
 * <p>The legacy `browserId` cookie retires alongside the localStorage key: this module also expires
 * it directly (rather than a server-side `Set-Cookie` on every response — see the identity-cut
 * design § Rejected alternatives for the trade). `boot.js`'s sole call site is the same call for
 * both sweeps.
 */
const LEGACY_PREFIXES = [
  "playerProfile.serde.",
  "browserId",
  "multiplayerSectionOpen",
];

export function sweepLegacyStorage() {
  const doomed = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (
      key != null &&
      LEGACY_PREFIXES.some((prefix) => key.startsWith(prefix))
    ) {
      doomed.push(key);
    }
  }
  for (const key of doomed) localStorage.removeItem(key);

  document.cookie = "browserId=; Path=/; Max-Age=0";
}
